var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UpsertRowWorkflowActionForm',{attrs:{"enable-row-id":"","workflow-action":_vm.workflowAction,"default-values":_vm.defaultValues.service},on:{"values-changed":function($event){_vm.values.service = { ..._vm.workflowAction.service, ...$event }}}})
}
var staticRenderFns = []

export { render, staticRenderFns }